
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FAQSection from './FAQKeyword';
import Testimonialskeyword from './TestimonialKeyword';
function Urbaniaonrentinpimprichichwad() {



    const cardData =
    {
        keyword: '  Urbania On Rent in Pimpri Chinchwad',
        heading: 'Samarth Travels: Urbania On Rent in Pimpri Chinchwad',
        headingDescription: 'Samarth Travels offers Urbania on rent in Pimpri Chinchwad, ideal for local sightseeing, airport transfers, outstation trips, and group tours. Our premium Force Urbania vehicles feature air-conditioning, push-back seats, and spacious interiors for a comfortable and relaxed journey. With experienced drivers, transparent pricing, and a strong focus on customer satisfaction, Samarth Travels ensures a smooth and enjoyable travel experience.',

        top: 'Top Places to Visit in Pune with Samarth Travels',

       "topPlaces": [
    {
      "title": "Shaniwar Wada",
      "description": "Shaniwar Wada is a majestic 18th-century fortification located in the heart of Pune. Once the seat of the powerful Peshwas of the Maratha Empire, it is renowned for its historical significance, massive gateways, and intriguing legends, including ghost stories tied to its mysterious past. Despite being partially destroyed by fire, the remaining structures, especially the Delhi Gate and the fort’s expansive garden layout, provide a fascinating glimpse into Maratha architecture and political history."
    },
    {
      "title": "Aga Khan Palace",
      "description": "Built in 1892 by Sultan Aga Khan III, this sprawling palace is an architectural gem and a key monument in India’s freedom struggle. It served as a prison for Mahatma Gandhi, Kasturba Gandhi, and other leaders during the Quit India Movement. The palace features Italian arches, sprawling gardens, and houses a museum that contains personal belongings of Gandhi and historical photographs. It is also the final resting place of Kasturba Gandhi and Mahadev Desai, adding to its solemn importance."
    },
    {
      "title": "Sinhagad Fort",
      "description": "Located about 30 kilometers from Pune, Sinhagad Fort sits atop the Sahyadri mountains and is a favorite trekking destination for locals and tourists alike. With a history dating back over a thousand years, the fort was famously the site of the battle between the Marathas and the Mughals in 1670. Visitors are drawn to its rugged beauty, crumbling fortifications, and sweeping views of the surrounding valleys, especially during monsoons when the hills are lush green and covered in mist."
    },
    {
      "title": "Pataleshwar Cave Temple",
      "description": "This 8th-century rock-cut temple is carved entirely from a single basalt rock and dedicated to Lord Shiva. Nestled quietly amidst urban Pune, Pataleshwar offers a striking contrast to the city’s bustle. It features a circular Nandi Mandapa and intricately carved columns and sanctums. A protected monument under the Archaeological Survey of India, it’s a peaceful retreat and an excellent example of early Indian rock architecture."
    },
    {
      "title": "Dagdusheth Halwai Ganpati Temple",
      "description": "One of the most famous Ganesh temples in India, Dagdusheth Halwai Ganpati Temple attracts millions of devotees every year, especially during Ganesh Chaturthi. The temple’s grand idol of Lord Ganesh is adorned with gold and jewelry, symbolizing prosperity and devotion. Built by a sweetmaker in the 1800s, the temple also engages in numerous social and cultural initiatives, making it both a religious and community hub."
    },
    {
      "title": "Raja Dinkar Kelkar Museum",
      "description": "Founded by Dr. Dinkar Kelkar in memory of his son, this museum is a treasure trove of Indian heritage. It houses over 20,000 artifacts, including musical instruments, ancient utensils, sculptures, paintings, and even quirky items like betel nut crackers and door frames. The collection offers insight into the daily lives and traditions of Indians across centuries, and its carefully curated exhibits make it a cultural landmark in Pune."
    },
    {
      "title": "Parvati Hill and Temple",
      "description": "Parvati Hill is one of Pune’s oldest heritage sites and offers a combination of spiritual serenity and scenic views. Climbing 103 steps leads to a temple complex dedicated to Goddess Parvati and Lord Shiva. The hill also hosts a small museum, Peshwa-era relics, and panoramic views of the cityscape below, making it ideal for morning walks and peaceful contemplation."
    },
    {
      "title": "Osho Ashram",
      "description": "Located in the serene and green Koregaon Park area, the Osho International Meditation Resort is a global center for spiritual seekers. It offers dynamic meditation sessions, wellness therapies, and luxurious facilities in a Zen-like atmosphere. Known for attracting international visitors, the ashram promotes mindfulness, inner peace, and holistic living through Osho’s teachings."
    },
    {
      "title": "Pune Okayama Friendship Garden",
      "description": "Inspired by the 300-year-old Okayama Korakuen Garden in Japan, this beautifully landscaped space—also known as Pu La Deshpande Garden—is perfect for nature lovers and photographers. The garden features flowing streams, lush lawns, bridges, and seasonal flowers, offering a tranquil escape right in the city. It’s ideal for evening walks and peaceful getaways."
    },
    {
      "title": "Katraj Snake Park and Rajiv Gandhi Zoological Park",
      "description": "Spread over 130 acres, this complex features a zoo, snake park, and animal rescue center. The snake park houses over 160 species of snakes, including cobras and pythons, while the zoo includes tigers, leopards, elephants, and more. Educational exhibits make it an informative and fun spot for children and families, combining entertainment with awareness about wildlife conservation."
    }
  ],

"services": [
    {
        "name": "Urbania on Rent in Pimpri Chinchwad",
        "description": "Samarth Travels offers Urbania on rent in Pimpri Chinchwad for a wide range of travel needs including city tours, events, and family outings. Our Urbania vans are known for their modern features, comfort, and efficiency—ideal for smooth transportation within the PCMC area or to nearby destinations. With experienced drivers and timely service, we ensure a hassle-free travel experience for groups of all sizes."
    },
    {
        "name": "Urbania Vehicle Rental in Pimpri Chinchwad",
        "description": "Looking for reliable Urbania vehicle rental in Pimpri Chinchwad? Samarth Travels provides well-maintained Urbania vans that are perfect for corporate, personal, and leisure travel. Whether it’s a short city transfer or a weekend getaway, our vehicles come equipped with air-conditioning, plush seating, and ample space, ensuring a comfortable ride for every passenger."
    },
    {
        "name": "Urbania for Rent Pimpri Chinchwad",
        "description": "Get access to top-quality Urbania for rent in Pimpri Chinchwad with Samarth Travels. Ideal for family outings, team off-sites, and event travel, our vehicles offer convenience, space, and a smooth ride. We provide flexible rental options and professional service, making group travel easy and affordable across PCMC and beyond."
    },
    {
        "name": "Urbania Hire for Corporate Events Pimpri Chinchwad",
        "description": "For corporate events in Pimpri Chinchwad, hire a premium Urbania van from Samarth Travels. Our vehicles are perfect for transporting employees, clients, and executives to seminars, meetings, and team-building sessions. We ensure timely pickups, professional drivers, and clean interiors to support a seamless corporate travel experience."
    },
    {
        "name": "Urbania on Rent for Family Trips Pimpri Chinchwad",
        "description": "Make your family trips from Pimpri Chinchwad more enjoyable with our Urbania rentals. Designed for comfort and safety, our vehicles offer plenty of space, reclining seats, and smooth suspension—perfect for children and seniors alike. Whether you’re traveling to a nearby hill station or a special celebration, our Urbania vans deliver a memorable ride."
    },
    {
        "name": "Urbania Hire for Picnics in Pimpri Chinchwad",
        "description": "Planning a picnic with friends or colleagues? Hire an Urbania from Samarth Travels in Pimpri Chinchwad. With ample seating, air-conditioning, and space for bags and food supplies, our vans are the ideal travel companion for a fun day out. Enjoy a comfortable and connected journey as your group travels together in style."
    },
    {
        "name": "Rent Urbania for Outstation Trips Pimpri Chinchwad",
        "description": "Samarth Travels offers Urbania rentals for outstation trips from Pimpri Chinchwad. Whether you're heading to Lonavala, Mahabaleshwar, or Mumbai, our Urbania vans are perfect for long-distance group travel. Equipped with modern comforts and driven by professionals, we ensure your trip is smooth, safe, and enjoyable from start to finish."
    },
    {
        "name": "Luxury Urbania on Rent in Pimpri Chinchwad",
        "description": "Experience premium group travel with our luxury Urbania on rent in Pimpri Chinchwad. Featuring plush interiors, entertainment systems, air-conditioning, and ample legroom, our high-end Urbania vans offer a stylish and comfortable ride. Ideal for weddings, VIP transport, or executive trips that require a touch of sophistication."
    },
    {
        "name": "Urbania 14-Seater Rental Pimpri Chinchwad",
        "description": "Need to transport a medium-sized group? Our Urbania 14-seater rental service in Pimpri Chinchwad is the perfect solution. With wide seating, AC, and luggage capacity, these vans are ideal for school outings, corporate teams, and extended families. Ride together, relax, and enjoy the journey with our dependable vehicles and professional service."
    },
    {
        "name": "Urbania Rental for Airport Transfers Pimpri Chinchwad",
        "description": "Ensure timely and smooth airport transfers with our Urbania rental service in Pimpri Chinchwad. Whether it's pickup or drop-off for individuals or groups, our vehicles are ideal for handling luggage and passengers with comfort. We monitor flight timings and offer reliable service, making us a trusted option for airport commutes."
    },
    {
        "name": "Urbania on Rent for Sightseeing Pimpri Chinchwad",
        "description": "Explore Pune and nearby attractions with our Urbania sightseeing rental from Pimpri Chinchwad. Perfect for families, tourist groups, or school tours, our vans offer comfort, AC, and a smooth ride for a full day of exploration. Enjoy the journey as much as the destination with Samarth Travels’ Urbania rental services."
    }
],
"tableData": [
    ["Urbania on Rent in Pimpri Chinchwad", "Urbania Vehicle Rental in Pimpri Chinchwad"],
    ["Urbania for Rent Pimpri Chinchwad", "Urbania Hire for Corporate Events Pimpri Chinchwad"],
    ["Urbania on Rent for Family Trips Pimpri Chinchwad", "Urbania Hire for Picnics in Pimpri Chinchwad"],
    ["Rent Urbania for Outstation Trips Pimpri Chinchwad", "Luxury Urbania on Rent in Pimpri Chinchwad"],
    ["Urbania 14-Seater Rental Pimpri Chinchwad", "Urbania Rental for Airport Transfers Pimpri Chinchwad"],
    ["Urbania on Rent for Sightseeing Pimpri Chinchwad", ""]
],


"whychoose": [
    {
        "WhyChooseheading": "Reliable Force Urbania Rental Service in Pimpri Chinchwad",
        "WhyChoosedescription": "We offer trusted and professional Force Urbania van rental services in Pimpri Chinchwad for all kinds of group travel and events. Whether you're planning a corporate event, wedding, family gathering, or a school trip, we ensure your group travels comfortably and on time."
    },
    {
        "WhyChooseheading": "Spacious and Comfortable Force Urbania Vans for Any Group Size",
        "WhyChoosedescription": "Our fleet of Force Urbania vans includes options for 9 to 17 passengers, with each van equipped with spacious reclining seats, air-conditioning, ample legroom, and USB charging ports to ensure a comfortable and enjoyable journey for all your passengers."
    },
    {
        "WhyChooseheading": "Professional and Experienced Drivers in Pimpri Chinchwad",
        "WhyChoosedescription": "Our drivers are skilled professionals who prioritize punctuality, safety, and comfort. They are familiar with the roads of Pimpri Chinchwad and the surrounding areas, ensuring timely pickups and drop-offs, and smooth coordination throughout your trip."
    },
    {
        "WhyChooseheading": "Affordable and Transparent Pricing for Urbania Rentals",
        "WhyChoosedescription": "We offer competitive and transparent pricing with no hidden charges. Whether you need the van for a few hours or an entire day, we provide flexible and budget-friendly rental packages that match your event requirements."
    },
    {
        "WhyChooseheading": "24/7 Availability for All Your Event and Travel Needs",
        "WhyChoosedescription": "We understand that events can happen at any time. That’s why our Force Urbania van rental services are available 24/7 in Pimpri Chinchwad, giving you the flexibility to schedule your transportation whenever needed, be it in the early morning or late at night."
    },
    {
        "WhyChooseheading": "Simple and Convenient Booking with Real-Time Updates",
        "WhyChoosedescription": "Booking your Force Urbania rental is fast and easy through our website or customer support. After booking, you’ll receive real-time tracking updates, driver contact details, and information on van arrivals, ensuring smooth and efficient event coordination."
    },
    {
        "WhyChooseheading": "Well-Maintained and Sanitized Force Urbania Vans",
        "WhyChoosedescription": "Our Force Urbania vans are maintained to the highest cleanliness and safety standards. Each van is thoroughly cleaned and sanitized before every trip, ensuring a hygienic and safe environment for all passengers."
    },
    {
        "WhyChooseheading": "Flexible Payment Options for Convenience",
        "WhyChoosedescription": "We offer a variety of payment methods, including UPI, credit/debit cards, digital wallets, and cash, allowing you to easily complete your booking in the most convenient and secure way."
    }
]




















    }

const faqData = [
    {
        id: 1,
        question: 'How can I rent a Force Urbania in Pimpri Chinchwad with Samarth Travels?',
        answer: 'Renting a Force Urbania in Pimpri Chinchwad is easy with Samarth Travels. You can contact us by phone or through our website. Just provide your travel details including date, route, and number of passengers, and we’ll take care of the rest.',
    },
    {
        id: 2,
        question: 'What seating capacities are available for Urbania vans in Pimpri Chinchwad?',
        answer: 'Samarth Travels offers 13+1 and 17+1 seater Force Urbania vans in Pimpri Chinchwad. These vans are suitable for group travel, corporate transfers, family functions, and outstation trips.',
    },
    {
        id: 3,
        question: 'What are the rental rates for Force Urbania in Pimpri Chinchwad?',
        answer: 'Rental rates start from ₹35/km for 13-seater and ₹36/km for 17-seater Urbania vans. We also offer local packages such as 4 hours/35 km and 8 hours/80 km, as well as daily rental options for outstation travel.',
    },
    {
        id: 4,
        question: 'Are the Urbania vans available for both local and outstation use?',
        answer: 'Yes, our Urbania vans can be booked for both local use within Pimpri Chinchwad and for outstation trips. The vans are comfortable, reliable, and well-maintained, making them ideal for any kind of journey.',
    },
    {
        id: 5,
        question: 'Do the Urbania vans have premium features?',
        answer: 'Absolutely. Our Force Urbania fleet includes vans with features like recliner seats, air conditioning, USB charging ports, personal AC vents, ample luggage space, and a music system.',
    },
    {
        id: 6,
        question: 'Can I customize my pickup and drop-off locations in Pimpri Chinchwad?',
        answer: 'Yes, Samarth Travels offers fully flexible pickup and drop-off points as per your requirement in and around Pimpri Chinchwad to ensure maximum convenience for your group.',
    },
    {
        id: 7,
        question: 'Is there customer support for bookings in Pimpri Chinchwad?',
        answer: 'Yes, we provide 24/7 customer support for all bookings including those from Pimpri Chinchwad. Our team is available for assistance at any time to ensure your travel experience is smooth and hassle-free.',
    },
];

const testimonials = [
    {
        name: 'Mr. Rajesh Gokhale',
        role: 'IT Project Manager',
        text: 'Booked a 17-seater Urbania from Samarth Travels in Pimpri Chinchwad for a team offsite. The vehicle was clean and modern, and the service was very professional. Will use them again for future events.',
        image: '/img/testimonial/testi_urbania_rajesh.jpg',
    },
    {
        name: 'Mrs. Sheetal Wagh',
        role: 'Event Organizer',
        text: 'I rented a 13-seater Force Urbania for a family function in Pimpri Chinchwad. The van was spacious and comfortable, and the driver was courteous. Samarth Travels handled everything smoothly. Highly recommended!',
        image: '/img/testimonial/testi_urbania_sheetal.jpg',
    },
];




























    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9860256019",
            "+91 9527500025",

        ],
        email: "samarthtravels9119@gmail.com"
    };


   const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: " Tempo Traveller Pune",
        },
        {
            place: "/images/keyword/2.jpg",
            text: " Tempo Traveller on Rent Pune",
        },
        {
            place: "/images/keyword/3.jpg",
            text: " Bus on Rent in Pune",
        },
        {
            place: "/images/keyword/4.jpg",
            text: " Tempo Traveller on Rent",
        },
        {
            place: "/images/keyword/5.jpg",
            text: " Tempo Traveller Rent in Pune",
        },
        {
            place: "/images/keyword/6.jpg",
            text: " Tempo Traveller Hire in Pune",
        },
        {
            place: "/images/keyword/7.jpg",
            text: " Mini Bus for Rent",
        },

        {
            place: "/images/keyword/8.jpg",
            text: " Bus on Rent Hire",
        },

        {
            place: "/images/keyword/9.jpg",
            text: " Bus on Rent Pune",
        },
        {
            place: "/images/keyword/10.jpg",
            text: " Bus Rental in Pune",
        },

        {
            place: "/images/keyword/11.jpg",
            text: " Hire Tempo Traveller",
        },
        {
            place: "/images/keyword/12.jpg",
            text: " Bus Hire in Pune",
        },
        {
            place: "/images/keyword/13.jpg",
            text: " Ac Tempo Traveller Rent Pune",
        },
        {
            place: "/images/keyword/14.jpg",
            text: " Bus Hire For Outstation",
        },
        {
            place: "/images/keyword/15.jpg",
            text: " Bus on Rent for Local",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " Bus Rental For Wedding",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Bus Rent for Marriage",
        },
        {
            place: "/images/keyword/18.jpg",
            text: " Bus Rental For Corporate Events",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "  Bus Rental for Tour",
        },

        {
            place: "/images/keyword/20.jpg",
            text: "Bus Rental For Corporate in Pune",
        },
        {
            place: "/images/keyword/21.jpg",
            text: " Tempo Traveller on Rent in Pune",
        },
        {
            place: "/images/keyword/22.jpg",
            text: " AC Bus On Rent",
        },
        {
            place: "/images/keyword/23.jpg",
            text: " Non Ac Bus Rental Service",
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Bus on Hire on Pune to Mahabaleshwar Package Tour ",
        },
        {
            place: "/images/keyword/25.jpg",
            text: "Bus Hire for Picnic",
        },
    ];


    const images = [
        { src: "/images/fleets/1.jpg", alt: "Image 1" },
        { src: "/images/fleets/2.jpg", alt: "Image 1" },
        { src: "/images/fleets/3.jpg", alt: "Image 1" },
        { src: "/images/fleets/4.jpg", alt: "Image 1" },
        { src: "/images/fleets/5.jpg", alt: "Image 1" },
        { src: "/images/fleets/6.jpg", alt: "Image 1" },
        { src: "/images/fleets/7.jpg", alt: "Image 1" },
        { src: "/images/fleets/8.jpg", alt: "Image 1" },
        { src: "/images/fleets/9.jpg", alt: "Image 1" },


    ];



const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Urbania On Rent in Pimpri Chinchwad",
  "image": "https://samarthtravels.com/assets/images/urbania-on-rent-pimpri-chinchwad.jpg",
  "description": "Rent a luxury Urbania vehicle in Pimpri Chinchwad for family trips, corporate events, picnics, sightseeing, and more. Affordable and comfortable rental services for local and outstation travel, including airport transfers and family tours.",
  "brand": {
    "@type": "Brand",
    "name": "Samarth Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "5471"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "25000",
    "availability": "https://schema.org/InStock",
    "url": "https://samarthtravels.com/urbania-on-rent-pimpri-chinchwad"
  }
};





    return (
        <div>

<Helmet>
  <title>Urbania On Rent in Pimpri Chinchwad | Luxury & Affordable Vehicle Hire | Samarth Travels</title>
  <meta 
    name="description" 
    content="Rent a luxury Urbania vehicle in Pimpri Chinchwad for family trips, corporate events, picnics, sightseeing, and more. Affordable and comfortable rental services for local and outstation travel, including airport transfers and family tours." 
  />
  <meta 
    name="keywords" 
    content="Urbania on rent in Pimpri Chinchwad, Urbania vehicle rental in Pimpri Chinchwad, Urbania for rent Pimpri Chinchwad, Urbania hire for corporate events Pimpri Chinchwad, Urbania on rent for family trips Pimpri Chinchwad, Urbania hire for picnics in Pimpri Chinchwad, Rent Urbania for outstation trips Pimpri Chinchwad, Luxury Urbania on rent in Pimpri Chinchwad, Urbania 14-seater rental Pimpri Chinchwad, Urbania rental for airport transfers Pimpri Chinchwad, Urbania on rent for sightseeing Pimpri Chinchwad" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>



            <div className="breadcumb-wrapper" data-bg-src="/images/breadcumb-bg.jpg">
                <div className="container">
                    <div className="breadcumb-content">
                        <h1 className="breadcumb-title text-center">{cardData.keyword}</h1>
                    </div>
                </div>
            </div>



            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/43.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#322E77', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2 bg-foootr'>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Samarth Travels </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">


                                                <FAQSection faqs={faqData} accordionId="drivingAccordion" />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <Testimonialskeyword
                                data={testimonials}
                                title="What Our Clients Are Saying"
                                subtitle="Customer Feedback"
                            />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #FF8F1F',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#FF8F1F' }}>
                                            <h4 className=" lead fw-semibold whitt textt-dark">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+919860256019" className="d-block  text-white">+91 9860256019</a>
                                                <a href="tel:+919527500025" className="d-block  text-white">+91 9527500025</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#FF8F1F' }}>
                                                <h4 className=" fw-semibold lead whitt textt-dark">Email</h4>
                                                <a href="mailto:samarthtravels9119@gmail.com" className=" text-white d-block">
                                                    samarthtravels9119@gmail.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#FF8F1F' }}>
                                                <h4 className=" fw-semibold lead whitt textt-dark">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Samarth Travels <br />
                                                        Flat no 201, Juhi Building, Suyash Shrushti Society, Tukai darshan Hadapsar, Pune- 411028
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Urbaniaonrentinpimprichichwad;